import React, { Component } from 'react';
import { Header, HeaderType } from '../../components/header';
import Footer from '../../components/footer';
import { shape, arrayOf, string, bool } from 'prop-types';
import { PageTreeType } from '../../utils/page-tree-type';
import { ResourceType } from '../../components/card';
import './contact.less';
import Breadcrumbs from '../../components/breadcrumbs';
import RemoteReactApp from '../../components/remote-react-app';
import { getFeatureGate } from '../../../statsig/statsig-client';
import Logger from '../../../logger';

export default class ContactPage extends Component {
    componentDidMount() {
        (async function () {
            const renderASHA = await getFeatureGate('render_asha', false);
            Logger.info('ContactPage Feature Gate Value', renderASHA);
        })();
    }
    render() {
        const {
            entry: { resourceCards, header, id, preview, context },
            pageTree
        } = this.props;

        return (
            <div
                className="contact flex-column-page"
                data-testid="page-template"
            >
                <div className="content-wrapper">
                    <Header
                        resources={resourceCards}
                        logo={header.atlassianSupportLogo}
                        atlassianSupportLogo={header.atlassianSupportLogo}
                        cloudProducts={header.cloudProducts}
                        serverProducts={header.serverProducts}
                        id={header.id}
                        showPreviewBanner={preview}
                        additionalLinks={header.additionalLinks}
                        pageId={id}
                    />
                    <main className="main-content-container margin-top-large">
                        <div className="contact__sub-header">
                            <Breadcrumbs
                                pageTree={pageTree}
                                entryId={id}
                                context={context}
                            />
                        </div>
                        <div className="contact__forms">
                            <RemoteReactApp
                                appTargetId="support-form-app"
                                manifestUrlProvider={() =>
                                    window.CONTACT_FORMS_MANIFEST
                                }
                                filesFilter={['index.js', 'index.css']}
                                includeLoadingSpinner={true}
                                executeAfterMount={() => {
                                    window.SUPPORT_FORM_APP = {
                                        IS_PARTNER_SUPPORT_TYPE: false
                                    };
                                }}
                            />
                        </div>
                    </main>
                </div>
                <Footer
                    logo={header.atlassianLogo.url}
                    className={'margin-top-large'}
                />
            </div>
        );
    }
}

ContactPage.propTypes = {
    entry: shape({
        resourceCards: shape({
            cards: arrayOf(ResourceType)
        }),
        header: HeaderType,
        id: string.isRequired,
        preview: bool
    }),
    pageTree: PageTreeType
};
